import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const OutstandingRevenue = {
	name: NAME,
	router,
	apiProvider,
};
